import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AgroHttpUtil } from "./service/agro.http.util";
import { AgroConfigBackEnd } from "./service/agro.backend.util";
import { AgroDateUtil } from "./service/agro.date.util";
import { ModelContext } from "./service/agro.model.context";
import { AgroCPFUtils } from "./service/agro.cpf.utils";
import { UserTokenCanaService } from "./service/cana/agro.user-token-cana";
import { AgroCryptoUtil } from "./service/agro.crypt.util";
import { UserTokenService } from "./service/convergencia/agro.user-token";
import './prototypes/date-prototype';
import './util/date-util'
import { NotificationHandlerService } from "./service/notification-handler.service";

@NgModule({
  imports: [
    CommonModule
  ],

  providers: [
    AgroHttpUtil,
    AgroConfigBackEnd,
    AgroDateUtil,
    ModelContext,
    AgroCPFUtils,
    UserTokenCanaService,
    UserTokenService,
    AgroCryptoUtil,
    NotificationHandlerService
  ]
})
// Módulo principal
export class AgroUtil { }